module.exports = require("@agm/core/services/managers/kml-layer-manager");